/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import { call, put, takeEvery, takeLatest, take, cancel, delay } from 'redux-saga/effects';
import { GET_WMI_CREDENTIALS, POLL_WMI_START, POLL_WMI_STOP } from './actionTypes';
import { fetchWMISuccess, fetchWMIFailure } from './actions';
import { Credentials } from './credentials'

// worker Saga: will be fired on GET_WMI_CREDENTIALS actions
function* fetchWMICreds() {
  try {
    const response = yield call(Credentials.getWMIs)
    yield put(fetchWMISuccess(response.data))
  } catch (error) {
    yield put(fetchWMIFailure(error))
  }
}

function* pollWMICreds() {
  while (true) {
    yield delay(30000)
    yield call(fetchWMICreds)
  }
}

/*
  Starts fetchWMICreds on each dispatched `GET_WMI_CREDENTIALS` action.
  Allows concurrent fetches of user.
*/
export function* getWmiSagaDetails() {
  yield takeEvery(GET_WMI_CREDENTIALS, fetchWMICreds)
}


export function* wmiPollingSaga() {
  while (true) {
    const watcherInstance = yield takeLatest(POLL_WMI_START, pollWMICreds)
    // cancel polling on POLL_HUBS_STOP
    yield take(POLL_WMI_STOP)
    yield cancel(watcherInstance)
  }
}

